import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.names, (item, index) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: index
    }, [parseInt($props.modeltype) === index + 1 ? (_openBlock(), _createBlock(_resolveDynamicComponent(item), _mergeProps({
      key: 0,
      ref_for: true
    }, _ctx.$attrs), null, 16)) : _createCommentVNode("", true)], 64);
  }), 128);
}